"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.blacklist = exports.Grid = exports.Inline = exports.Flex = exports.Box = exports.Base = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _cleanTag = _interopRequireDefault(require("../clean-tag"));

var _styledSystem = require("styled-system");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
} // Custom system props


var flexGrow = (0, _styledSystem.style)({
  prop: 'flexGrow'
});
var flexShrink = (0, _styledSystem.style)({
  prop: 'flexShrink'
});
var cursor = (0, _styledSystem.style)({
  prop: 'cursor'
});
var transform = (0, _styledSystem.style)({
  prop: 'transform'
});
var textTransform = (0, _styledSystem.style)({
  prop: 'textTransform'
});
var transition = (0, _styledSystem.style)({
  prop: 'transition',
  key: 'transitions'
}); // get all system props

var allPropTypes = Object.keys(_styledSystem.styles).filter(function (key) {
  return typeof _styledSystem.styles[key] === 'function';
}).reduce(function (a, key) {
  return Object.assign(a, _styledSystem.styles[key].propTypes);
}, {}); // prevent them from being passed to dom element

var blacklist = [].concat(Object.keys(allPropTypes), ['theme', 'cursor', 'transform', 'flexGrow', 'flexShrink', 'textTransform', 'transition', 'zIndex', 'suppressClassNameWarning', 'Type', 'staticContext']);
exports.blacklist = blacklist;
var Base = (0, _styledComponents.default)(_cleanTag.default)(_templateObject(), _styledSystem.space, flexGrow, flexShrink, cursor, textTransform, transform, transition, _styledSystem.width, _styledSystem.fontSize, _styledSystem.color, _styledSystem.fontFamily, _styledSystem.textAlign, _styledSystem.lineHeight, _styledSystem.fontWeight, _styledSystem.fontStyle, _styledSystem.letterSpacing, _styledSystem.display, _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.height, _styledSystem.maxHeight, _styledSystem.minHeight, _styledSystem.sizeWidth, _styledSystem.sizeHeight, _styledSystem.size, _styledSystem.ratioPadding, _styledSystem.ratio, _styledSystem.verticalAlign, _styledSystem.alignItems, _styledSystem.alignContent, _styledSystem.justifyItems, _styledSystem.justifyContent, _styledSystem.flexWrap, _styledSystem.flexBasis, _styledSystem.flexDirection, _styledSystem.flex, _styledSystem.justifySelf, _styledSystem.alignSelf, _styledSystem.order, _styledSystem.gridGap, _styledSystem.gridColumnGap, _styledSystem.gridRowGap, _styledSystem.gridColumn, _styledSystem.gridRow, _styledSystem.gridAutoFlow, _styledSystem.gridAutoColumns, _styledSystem.gridAutoRows, _styledSystem.gridTemplateColumns, _styledSystem.gridTemplateRows, _styledSystem.gridTemplateAreas, _styledSystem.gridArea, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.borderRadius, _styledSystem.boxShadow, _styledSystem.opacity, _styledSystem.overflow, _styledSystem.background, _styledSystem.backgroundImage, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.backgroundSize, _styledSystem.position, _styledSystem.zIndex, _styledSystem.top, _styledSystem.right, _styledSystem.bottom, _styledSystem.left, _styledSystem.textStyle, _styledSystem.buttonStyle);
exports.Base = Base;
Base.defaultProps = {
  suppressClassNameWarning: true,
  blacklist: blacklist
};

var Box = function Box(props) {
  return React.createElement(Base, props);
};

exports.Box = Box;

var Flex = function Flex(props) {
  return React.createElement(Base, props);
};

exports.Flex = Flex;

var Grid = function Grid(props) {
  return React.createElement(Base, props);
};

exports.Grid = Grid;

var Inline = function Inline(props) {
  return React.createElement(Base, props);
};

exports.Inline = Inline;
Box.defaultProps = {
  suppressClassNameWarning: true,
  blacklist: blacklist
};
Flex.defaultProps = {
  suppressClassNameWarning: true,
  blacklist: blacklist,
  display: 'flex'
};
Grid.defaultProps = {
  suppressClassNameWarning: true,
  blacklist: blacklist,
  display: 'flex'
};
Inline.defaultProps = {
  suppressClassNameWarning: true,
  blacklist: blacklist,
  display: 'inline-block',
  is: 'span'
};
Box.displayName = 'Box';
Flex.displayName = 'Flex';
Grid.displayName = 'Grid';
Inline.displayName = 'Inline';